import {
  AfterViewInit,
  ApplicationRef,
  Component,
  ComponentRef,
  createComponent,
  Input,
  ViewChild,
  ViewContainerRef,
  ChangeDetectionStrategy
} from "@angular/core";
import {DateTimeEntry} from "./berth-visit-details.component";

@Component({
    selector: 'app-labeled-date-time',
    templateUrl: './labeled-date-time.component.html',
    styleUrls: ['./labeled-date-time.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LabeledDateTimeComponent implements AfterViewInit {
  @Input() info: DateTimeEntry;
  @Input() index: number;
  @Input() last: boolean;

  @ViewChild("holder", {read: ViewContainerRef, static: true}) holder: ViewContainerRef;

  constructor(private appRef: ApplicationRef) {
  }

  // Our child may use [(ngModel)], which isn't available in onNgInit
  ngAfterViewInit(): void {
      if (this.info.dateTimeType) {
        // Create component and replace the child(ren) of the hostElement
        const host: Element = document.getElementById(this.info.id);
        const dateField: ComponentRef<any> = createComponent(this.info.dateTimeType, {
          hostElement: host,
          environmentInjector: this.appRef.injector
        })
        this.appRef.attachView(dateField.hostView);
        if (this.info.init) {
          this.info.init(dateField);
        } else {
          dateField.instance.writeValue(this.info.time);
          dateField.instance.registerOnChange(this.info.onChanged);
        }
        dateField.instance.readonly = this.info.readonly;
      } else {
        this.holder.createEmbeddedView(this.info.dateTimeTemplate!);
      }
  }
}
